import { HTTPAPI } from "../base";

const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";
    return token;
}

const brandrep = {
    getList: (urlCriteria) => {        
        return HTTPAPI(grabToken())
        .get("/brandrep/list" + urlCriteria)
    },
    getAll: () => {        
        return HTTPAPI(grabToken())
        .get("/brandrep")
    },
    delete: (code) => {        
        return HTTPAPI(grabToken())
        .delete("/brandrep/" + code)
    },
    getOne: (code) => {        
        return HTTPAPI(grabToken())
        .get("/brandrep/" + code)
    },
    update: (code, data) => {
        return HTTPAPI(grabToken())
        .patch("/brandrep/" + code, data);
    },
    create: (data) => {
        return HTTPAPI(grabToken())
        .post("/brandrep/", data);
    },
    // signUp: (data) => {
    //     return HTTPAPI()
    //     .post("/users/register", data)
    // },
    // activateUser: (code) => {
    //     return HTTPAPI()
    //     .post("/users/activate", {code})
    // },
    // login: (data) => {
    //     return HTTPAPI()
    //     .post("/auth/login", data)
    // },    
    // logout: (data) => {        
    //     return HTTPAPI(grabToken())
    //     .post("/auth/logout", data)
    // },
    // forgotPass: (data) => {
    //     return HTTPAPI()
    //     .post("/users/forgotpass", data)
    // },
    // validateResetPassCode: (code) => {
    //     return HTTPAPI()
    //     .post("/users/validatepassreset", {code})
    // },
    // changePassword: (data) => {
    //     return HTTPAPI()
    //     .post("/users/changepass", data)
    // }
}

export default brandrep;
